import { Models } from "@hex-insights/app-modules";
import { CaseStyle, convertCase } from "@hex-insights/core";
import { StudentInjuryNote } from "../../../Utilities";
import * as ModelFormat from "../_General";

// Note: the functions defined in this file can be passed to model field components for consistent formatting.

/**
 * Formats the incidentTime field of the StudentInjuryNote model.
 */
export function incidentTime(value: StudentInjuryNote["incidentTime"] | null): string {
	if (!value) {
		return "Not specified";
	}
	return ModelFormat.time(value);
}

/**
 * Formats the incidentLocation field of the StudentInjuryNote model.
 */
export function incidentLocation(value: StudentInjuryNote["incidentLocation"] | null): string {
	if (!value) {
		return "Not specified";
	}
	return convertCase(value, CaseStyle.Title);
}

/**
 * Formats the wereOtherStudentsCauseOfInjury field of the StudentInjuryNote model.
 */
export function wereOtherStudentsCauseOfInjury(value: StudentInjuryNote["wereOtherStudentsCauseOfInjury"]): string {
	return value ? "Yes" : "No";
}

/**
 * Formats the causeOfInjury field of the StudentInjuryNote model.
 */
export function causeOfInjury(value: StudentInjuryNote["causeOfInjury"]): string {
	if (!value) {
		return "Not specified";
	}
	return Models.toString(value);
}

/**
 * Formats the medicalAttentionProvided field of the StudentInjuryNote model.
 */
export function medicalAttentionProvided(value: StudentInjuryNote["medicalAttentionProvided"]): string {
	if (!value) {
		return "Not specified";
	}
	return Models.toString(value);
}

/**
 * Formats the adultWhoProvidedMedicalAttention field of the StudentInjuryNote model.
 */
export function adultWhoProvidedMedicalAttention(value: StudentInjuryNote["adultWhoProvidedMedicalAttention"]): string {
	return Models.toString(value);
}

/**
 * Formats the isActionTakenHomeroomTeachersNotified field of the StudentInjuryNote model.
 */
export function isActionTakenHomeroomTeachersNotified(
	value: StudentInjuryNote["isActionTakenHomeroomTeachersNotified"],
): string {
	return Models.toString(value);
}

/**
 * Formats the isActionTakenParentNotifiedByPortal field of the StudentInjuryNote model.
 */
export function isActionTakenParentNotifiedByPortal(
	value: StudentInjuryNote["isActionTakenParentNotifiedByPortal"],
): string {
	return Models.toString(value);
}

/**
 * Formats the isActionTakenParentNotifiedByPhone field of the StudentInjuryNote model.
 */
export function isActionTakenParentNotifiedByPhone(
	value: StudentInjuryNote["isActionTakenParentNotifiedByPhone"],
): string {
	return Models.toString(value);
}

/**
 * Formats the isActionTakenParentsRequestedToCollectStudent field of the StudentInjuryNote model.
 */
export function isActionTakenParentsRequestedToCollectStudent(
	value: StudentInjuryNote["isActionTakenParentsRequestedToCollectStudent"],
): string {
	return Models.toString(value);
}

/**
 * Formats the isActionTakenParentNotificationNotNecessary field of the StudentInjuryNote model.
 */
export function isActionTakenParentNotificationNotNecessary(
	value: StudentInjuryNote["isActionTakenParentNotificationNotNecessary"],
): string {
	return Models.toString(value);
}

/**
 * Formats the isActionTakenOther field of the StudentInjuryNote model.
 */
export function isActionTakenOther(value: StudentInjuryNote["isActionTakenOther"]): string {
	return Models.toString(value);
}

/**
 * Formats the actionTakenOther field of the StudentInjuryNote model.
 */
export function actionTakenOther(value: StudentInjuryNote["actionTakenOther"]): string {
	return Models.toString(value);
}
